export default "__VITE_ASSET__69e3aee7__"